/**
 * A ticker as a reader knows it.
 *
 * The backtest archive names instruments fully qualified - "NASDAQ:MSTX" - and we store what we are
 * given, because the exchange is real information and throwing it away at import cannot be undone.
 * It is only ever noise on screen, though: a customer looking at a strategy card knows the exchange
 * or does not care, and the prefix costs the width the ticker itself needs.
 *
 * Anything without a colon is already what it should be and passes through untouched, which is what
 * every symbol imported before the exporter started qualifying them looks like.
 */
export function displayTicker(ticker: string): string;
export function displayTicker(ticker: string | null | undefined): string | null | undefined;
export function displayTicker(ticker: string | null | undefined) {
  if (!ticker) return ticker;

  const colon = ticker.indexOf(":");
  return colon === -1 ? ticker : ticker.slice(colon + 1);
}
